<div class="cob-dialog-wrapper mt-24 ml-24 mr-24">
	<div class="flex flex-col">
		<div class="flex flex-row w-100-percent pl-6">
			<div class="flex flex-col basis-full">
        <div [ngSwitch]="data?.title" class="fw-700 mat-headline-5 fs-20">
          <div *ngSwitchCase="'configPack'">{{ 'ERROR_DIALOG.CONFIGURATION_PACKAGE' | transloco }}</div>
          <div *ngSwitchCase="'envPack'">{{ 'ERROR_DIALOG.ENVIRONMENT_PACKAGE' | transloco }}</div>
          <div *ngSwitchCase="'referencePack'">{{ 'ERROR_DIALOG.REFERENCE_PACKAGE' | transloco }}</div>
        </div>
				<div class="fs-16 fw-500">{{ data?.jarName}}</div>
			</div>
      <div class="flex flex-col mr-24">
        <button class="flex justify-end h-30 pt-4 pr-8 pb-4 pl-8 download" (click)="downloadJson()">
            <span class="fs-16 fw-500 item flex items-center">
                <mat-icon class="h-18 w-18 mr-6" svgIcon="file_download"></mat-icon>
                {{ 'ERROR_DIALOG.DOWNLOAD' | transloco }}
            </span>
        </button>
    </div>
      <div class="flex flex-col mr-24">
        <button class="flex justify-end h-30 error-copy-class pt-4 pr-8 pb-4 pl-8"
            [ngClass]="[copy ? 'copied': 'copy']" (click)="copyText()">
            <span *ngIf="!copy" class="fs-16 fw-500 item flex items-center">
                <mat-icon class="h-18 w-18 mr-6" svgIcon="content_copy"></mat-icon>{{ 'ERROR_DIALOG.COPY' |
                transloco }}
            </span>
            <span *ngIf="copy" class="fs-16 fw-500 item flex items-center copied-text">
                <mat-icon class="h-18 w-18 mr-6" svgIcon="check"></mat-icon>{{ 'ERROR_DIALOG.COPIED' | transloco
                }}
            </span>
        </button>
    </div>
			<div class="flex flex-col mr-6">
        <mat-icon svgIcon="close" class="close-icon cursor-pointer" (click)="closeWithSlideOut()"></mat-icon>
			</div>
		</div>
		<mat-divider class="w-100-percent mt-16 mb-16 mat-divider"></mat-divider>
    <div class="flex flex-col packageContent mb-8">
      <div class="ml-12 mr-12 mb-20" *ngFor="let error of data?.description; let last = last">
        <div class="mb-8 fs-14 fw-400" *ngIf="error.code">
          <span class="error-text">"{{ 'ERROR_DIALOG.CODE' | transloco }}": </span>
          <span>"{{ error.code }}"</span>
        </div>
        <div class="mb-8 fs-14 fw-400" *ngIf="error.component">
          <span class="error-text">"{{ 'ERROR_DIALOG.COMPONENT' | transloco }}": </span>
          <span>"{{ error.component }}"</span>
        </div>
        <div class="mb-8 fs-14 fw-400" *ngIf="error.fieldName">
          <span class="error-text">"{{ 'ERROR_DIALOG.FIELDNAME' | transloco }}": </span>
          <span>"{{ error.fieldName }}"</span>
        </div>
        <div class="mb-8 fs-14 fw-400" *ngIf="error.message">
          <span class="error-text">"{{ 'ERROR_DIALOG.MESSAGE' | transloco }}": </span>
          <span>"{{ error.message }}"</span>
        </div>
        <div class="mb-8 fs-14 fw-400" *ngIf="error.type">
          <span class="error-text">"{{ 'ERROR_DIALOG.TYPE' | transloco }}": </span>
          <span>"{{ error.type }}"</span>
        </div>
        <mat-divider *ngIf="!last" class="w-100-percent mt-16 mb-16 mat-divider-inner"></mat-divider>
      </div>
    </div>
    <mat-divider class="w-100-percent mt-8 mb-16 mat-divider"></mat-divider>

    <div class="flex flex-row justify-center items-center mt-8 mb-8 ml-auto">
      <button class="white mr-20 report-letter-spacing" type="button" (click)="closeWithSlideOut()"> {{ 'ERROR_DIALOG.BACK' | transloco }} </button>
      <button *ngIf="hideReportButton" class="error-report-bg-color accent report-letter-spacing" type="button" (click)="openContactForm()"> {{ 'ERROR_DIALOG.REPORT' | transloco }} </button>
    </div>
	</div>
</div>
